import {PlotData} from "plotly.js"
import * as csDictionary from 'plotly.js/lib/locales/it';
import { CCGTSeries, TimeSeriesItem } from '../../Services/typescript-fetch-client';
import React, { useEffect, useState } from "react";
import Plot, {Figure} from "react-plotly.js";
import { ZoomElement } from "../../Models/ZoomElement";
import {DateTime} from "luxon";
import Icons from "plotly.js/src/fonts/ploticon"
import { LegendSerie } from "../PlotsSharedLegend/PlotsSharedLegend";

type Props = {
    ccgtSeries: CCGTSeries,
    viewName: string,
    maxY: number,
    isLandscape: boolean,
    isSinglePlantView: boolean,
    visibleSeries?: Map<string, LegendSerie>,
    zoom: ZoomElement,
    setZoom: React.Dispatch<React.SetStateAction<ZoomElement | null>>,
    zoomBack: () => void
    backToInitialZoom: () => void,
    height: number
};
const CCGTRealTimePlotlyComponent = (props: Props) => {
    let [plotState, setPlotState] = useState<Readonly<Figure>>(() => {
        return {
            layout: {
                showlegend: false,
                legend: { "orientation": "h" },
                margin: {
                    l: 35,
                    r: 15,
                    b: 37,
                    t: 25,
                    pad: 5
                },
                uirevision:'true',
                hovermode: "x",
                hoverdistance: 1,
                xaxis: {
                    //autorange: true,
                    tickformat: '',
                    range: props.zoom?.x.map((v: DateTime) => v.toJSDate())
                },
                yaxis: {
                    range: props.zoom?.y ? [...props.zoom?.y] : undefined
                },
                datarevision: 0
            },
            data: props.ccgtSeries ? [
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    fill: 'tozeroy',
                    name: 'Energia Prodotta',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 1.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PF',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 1.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PV',
                    line: {
                        color: '#',
                        shape: 'hv',
                        width: 1.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
					fill: 'tozeroy',
                    name: 'SB',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 1.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PVM',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 1.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'Energia Da Produrre',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 1.5
                    }
                },
                /*{
                    x: props.ccgtSeries.nominalPower ? props.ccgtSeries.nominalPower.map((timeSeriesItem: TimeSeriesItem) => (timeSeriesItem.dateKey) ? timeSeriesItem.dateKey.toString() : null) : [],
                    y: props.ccgtSeries.nominalPower ? props.ccgtSeries.nominalPower.map((timeSeriesItem: TimeSeriesItem) => (typeof(timeSeriesItem.value) != "undefined" && timeSeriesItem.value !== null) ?
                        timeSeriesItem.value! : 0) : [],
                    type: 'scatter',
                    mode: "lines",
                    hoverinfo: 'y+name',
                    name: 'Potenza Nominale',
                    line: {
                        shape: 'hv',
                        color: '#777777',
                        width: 0.5
                    }
                },*/
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PsMin1',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 0.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PsMin2',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 0.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PsMax1',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 0.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "lines",
                    name: 'PsMax2',
                    line: {
                        shape: 'hv',
                        color: '#',
                        width: 0.5
                    }
                },
                {
                    x: [],
                    y: [],
                    type: 'scatter',
                    mode: "none",
                    fill: "tozeroy",
                    name: 'BAD',
                    fillcolor: '#fcaf4999',
                    hoverinfo: 'x',
                    showlegend: false,
                    line: {
                        shape: 'vh'
                    }
                }
            ] : [],
            frames: []
        };
    });
    
    useEffect(() => {
        const serieNamesMap = {
            'PF': 'pf',
            'PV': 'pv',
            'SB': 'sb',
            'PVM': 'pvm',
            'Energia Da Produrre': 'pFfromDWH',
            'Energia Prodotta': 'prodotto',
            'PsMin1': 'psMin1',
            'PsMin2': 'psMin2',
            'PsMax1': 'psMax1',
            'PsMax2': 'psMax2',
            'BAD': 'badProdotto'
        }; 
        
        setPlotState((prev) => {
            let temp = {
                ...prev
            };

            for (let i = 0; i < temp.data.length; i++) {
                let dataName = serieNamesMap[temp.data[i].name ?? ''];
                (temp.data[i] as Partial<PlotData>).x = props.ccgtSeries[dataName] ? props.ccgtSeries[dataName].map((timeSeriesItem: TimeSeriesItem) => 
                    (timeSeriesItem.dateKey) ? timeSeriesItem.dateKey.toString() : null) : 
                    [];
                (temp.data[i] as Partial<PlotData>).y = props.ccgtSeries[dataName] ? props.ccgtSeries[dataName].map((timeSeriesItem: TimeSeriesItem) => 
                    (typeof(timeSeriesItem.value) != "undefined" && timeSeriesItem.value !== null) ? timeSeriesItem.value! : 0) : 
                    [];
            }
            prev.layout.datarevision = Number(prev.layout.datarevision!) + 1;
            
            return temp;
        });
    }, [props.ccgtSeries]);
    
    useEffect(() => {
        setPlotState(prev => {
            let temp = {
                ...prev
            };
            
            let activeSeries : (string[] | null) = typeof props.visibleSeries === "undefined" ? null : [];
            props.visibleSeries?.forEach((v, k) => {
                if(v.active){
                    activeSeries = (activeSeries ?? []).concat(v.controlledSeries);
                }
            }); 
            
            for(let i = 0; i < temp.data.length; i++){
                if(activeSeries === null || activeSeries.indexOf(temp.data[i].name ?? "") !== -1){
                    (temp.data[i] as Partial<PlotData>).visible = true;
                }
                else{
                    (temp.data[i] as Partial<PlotData>).visible = 'legendonly';
                }
                
                if(typeof props.visibleSeries !== "undefined" && props.visibleSeries.get(temp.data[i].name ?? "")?.color){
                    if((temp.data[i] as Partial<PlotData>).fillcolor) {
                        (temp.data[i] as Partial<PlotData>).fillcolor = props.visibleSeries.get(temp.data[i].name ?? "")?.color;
                    }
                    else if((temp.data[i] as Partial<PlotData>)?.line?.color){
                        (temp.data[i] as Partial<PlotData>).line!.color = props.visibleSeries.get(temp.data[i].name ?? "")?.color;
                    }
                }
            }
            prev.layout.datarevision = Number(prev.layout.datarevision!) + 1;
            
            return temp;
        });
    }, [props.visibleSeries]);
    
    useEffect(() => {
        if(props.zoom) {
            setPlotState(prev => {
                let temp = {
                    ...prev
                };

                if(props.zoom.x[0]?.isValid && props.zoom.x[1]?.isValid) {
                    temp.layout.xaxis!.range = props.zoom.x.map((v: DateTime) => v.toJSDate());
                    temp.layout.xaxis!.autorange = false;
                }
                else{
                    temp.layout.xaxis!.range = undefined;
                    temp.layout.xaxis!.autorange = true;
                }
                temp.layout.yaxis!.range = [...props.zoom.y];
                temp.layout.datarevision = Number(prev.layout.datarevision!) + 1;
                return temp;
            });
        }
    }, [props.zoom]);
    
    const setNewZoom = (eventData: any) =>  {
        if(eventData["xaxis.range[0]"] || eventData["xaxis.range[1]"] || eventData["yaxis.range[0]"] || eventData["yaxis.range[1]"]){
            props.setZoom(prev => {
                return {
                    x: [
                        eventData["xaxis.range[0]"] ?
                            DateTime.fromSQL(eventData["xaxis.range[0]"]) :
                            (prev ?
                                prev.x[0] :
                                DateTime.now().startOf("day")),
                        eventData["xaxis.range[1]"] ?
                            DateTime.fromSQL(eventData["xaxis.range[1]"]) :
                            (prev ?
                                prev.x[1] :
                                DateTime.now().startOf("day"))
                    ],
                    y: [
                        eventData["yaxis.range[0]"] ?
                            Number(eventData["yaxis.range[0]"]) :
                            (prev ?
                                prev.y[0] : 0),
                        eventData["yaxis.range[1]"] ?
                            Number(eventData["yaxis.range[1]"]) :
                            (prev ?
                                prev.y[1] : 0),
                    ]
                };
            });
        }
    }
    
    let graphClass = "graph" + (props.isLandscape ? "Landscape": "Portrait") + (props.isSinglePlantView ? "Single" : "Multiple") + (props.height === 2532 ? " ip-13" : "");
    
    return (
        <Plot
            data={plotState.data}
            layout={plotState.layout}
            config = {{
                displaylogo: false,
                // @ts-ignore
                locales: { 'it-IT': csDictionary },//make locale available to the plot
                locale: 'it-IT',//use the locale
                modeBarButtonsToRemove: [
                    'zoom2d',
                    'pan2d',
                    'zoomIn2d',
                    'zoomOut2d',
                    'autoScale2d',
                    'resetScale2d'
                ],
                modeBarButtonsToAdd: [
                    {
                        name: 'previousZoomLevel',
                        title: 'Zoom Indietro',
                        icon: Icons.zoom_minus,
                        click: (gd, ev) => {
                            props.zoomBack();
                        }
                    },
                    {
                        name: 'newResetScale',
                        title: 'Reset zoom',
                        icon: Icons.home,
                        click: (gd, ev) => {
                            props.backToInitialZoom();
                        }
                    }
                ],
                toImageButtonOptions: {
                    filename: props.viewName
                },
                showAxisDragHandles: false,
                doubleClick: false
            }}
            useResizeHandler={true}
            className={graphClass + " CCGTgraph"}
            onRelayout={setNewZoom}
            onAfterPlot={() => {}}
        />
    );
}

export default CCGTRealTimePlotlyComponent;